// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29a5e701","885":"a8fa9bc0"}[chunkId] + ".chunk.js";
};